// src/styles/components/MuiTooltip.js
const MuiTooltip = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      backgroundColor: theme.palette.grey[800],
      fontSize: '0.75rem',
      padding: '4px 8px',
      borderRadius: theme.shape.borderRadius,
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.grey[800],
    }),
  },
};

export default MuiTooltip;